import StickyServicesReveal from "../StickyServicesReveal";

export default function Home() {
  return (
    <div>
      <StickyServicesReveal />
    </div>

  );
}
